export { monitored, monitor, callMonitored, addMonitoringMessage, addMonitoringError, startFakeInternalMonitoring, resetInternalMonitoring, setDebugMode, startInternalMonitoring, } from './internalMonitoring';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/domain/internalMonitoring/index.js
// module id = 310
// module chunks = 0